import React from "react";
import { Link } from "react-router-dom";

import AnimationPoint from "./AnimationPoint";
import { TimelineLite } from "gsap/TimelineLite";

// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import beachHairBg from './img/Brand-page-header.png'

class Links extends React.Component {
  constructor(props) {
    super(props);

    const paused = true,
      delay = 1;

    this.state = { barOpen: false };

    this.Timeline = new TimelineLite({ paused, delay });
  }

  setUpAnimation() {
    this.Timeline.to("#link-bar", 0.3, { backgroundColor: "rgb(255,255,255)" });
    this.Timeline.to(".link-bar li", 0.2, {
      color: "rgb(0,0,0)",
      textShadow: "0",
    });
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", () => {});
  }

  addEventListeners() {
    let { barOpen } = this.state;

    document.addEventListener("scroll", () => {
      if (document.documentElement.scrollTop > 100 && !barOpen) {
        this.setState({ barOpen: true }, () => {
          this.animationStart();
        });
      } else if (document.documentElement.scrollTop < 100) {
        this.setState({ barOpen: false }, () => {
          this.animationReverse();
        });
      }
    });
  }

  componentDidMount() {
    this.setUpAnimation();
    this.addEventListeners();
  }

  animationStart() {
    this.Timeline.play();
  }

  animationReverse() {
    this.Timeline.reverse();
  }

  animationRestart() {
    this.Timeline.restart();
  }

  render() {
    return (
      <div>
        <div className='link-bar' id='link-bar'>
          <ul>
            <Link to={"/home"}>
              <li className='link-list' id='link-list'>
                Home
              </li>
            </Link>
            <Link to={"/brands"}>
              <li className='link-list'>Brands</li>
            </Link>
            <Link to={"/about"}>
              <li className='link-list'>About</li>
            </Link>
            <Link to={"/faq"}>
              <li className='link-list'>FAQ</li>
            </Link>
            <Link to={"/story"}>
              <li className='link-list'>Story</li>
            </Link>
            <Link to={"/giftcards"}>
              <li className='link-list'>Gift Cards</li>
            </Link>
          </ul>
        </div>
        <br />
        <br />
        <AnimationPoint enter={this.animationEnter} topOffset='1px' />
      </div>
    );
  }
}

export default Links;



// WEBPACK FOOTER //
// ./src/components/Links.js